export const allExpenseData = [
  {
    amount:17000,
    category:'Gifts',
    type:'Income',
    details:'Gift form Mr Mosses',
    date: '05-07-2022',
  },
  {
    amount:500,
    category:'Food',
    type:'Expense',
    details:'bought potatoes for 500frs or $0.81',
    date: '05-08-2022',
  },
  {
    amount:250,
    category:'Gifts',
    type:'Income',
    details:'Gift form Mr Mosses to pay taxi, this was the change',
    date: '05-09-2022',
  },
  {
    amount:600,
    category:'Food',
    type:'Expense',
    details:'bought bread for 600frs or $0.97',
    date: '05-11-2022',
  },
  {
    amount:100,
    category:'Car',
    type:'Expense',
    details:'100cfa on taxi',
    date: '05-14-2022',
  },
  {
    amount:4000,
    category:'Food',
    type:'Expense',
    details:'bought eggs 2000, granuteoil 1300, bread 500, watermelon 200 potatoes 500',
    date: '05-15-2022',
  }
  ,
  {
    amount:50,
    category:'Other',
    type:'Expense',
    details:'black rappen 50cfa',
    date: '05-15-2022',
  }
  ,
  {
    amount:1000,
    category:'Bills',
    type:'Expense',
    details:'1000 on data creadit',
    date: '05-15-2022',
  },
  {
    amount:10000,
    category:'Gifts',
    type:'Expense',
    details:'10000 to mom',
    date: '05-17-2022',
  },
  {
    amount:5000,
    category:'Extra income',
    type:'Income',
    details:'5000 form rearanging Mr Moh office and cleaning it',
    date: '05-17-2022',
  },
  {
    amount:250,
    category:'Gifts',
    type:'Income',
    details:'Gift form me,money i had befor tracking',
    date: '05-18-2022',
  },
  {
    amount:1250,
    category:'Food',
    type:'Expense',
    details:'1250 francs to buy milk',
    date: '05-18-2022',
  },

  {
    amount:1500,
    category:'Bills',
    type:'Expense',
    details:'1500 francs to for electronic(current) ',
    date: '05-18-2022',
  },
  {
    amount:1500,
    category:'Bills',
    type:'Expense',
    details:'1000 for orange internet and 500 for Mtn internet',
    date: '05-23-2022',
  },
  {
    amount:1500,
    category:'Food',
    type:'Expense',
    details:'1500 for buying spices for food',
    date: '05-23-2022',
  },
  {
    amount:200,
    category:'Food',
    type:'Expense',
    details:'fresh tomato for 100 and sashet tomato for 100',
    date: '05-27-2022',
  },
  {
    amount:200,
    category:'Other',
    type:'Expense',
    details:'omo to wash my dreses for 200',
    date: '05-27-2022',
  },
  {
    amount:100,
    category:'Gifts',
    type:'Expense',
    details:'gave Eli of Tabaken 100 to buy pair',
    date: '05-18-2022',
  },
  ,
  {
    amount:100000,
    category:'Debt',
    type:'Expense',
    details:'capital i am to return to boris',
    date: '07-29-2022',
  },
  ,
  {
    amount:60000,
    category:'Debt',
    type:'Expense',
    details:'capital i am to return to hope',
    date: '07-29-2022',
  },
  {
    amount:10000,
    category:'Bills',
    type:'Expense',
    details:'Charges for widrawal of 200000 salary',
    date: '07-29-2022',
  },
  {
    amount:200000,
    category:'Salary',
    type:'Income',
    details:'Gift form me,money i had befor tracking',
    date: '07-29-2022',
  },

]
